import { ExternalLink } from "@octopusdeploy/design-system-components";
import type { Repository } from "@octopusdeploy/octopus-server-client";
import { HasGitPersistenceSettings } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { sortBy } from "lodash";
import React from "react";
import InternalLink from "~/components/Navigation/InternalLink";
import { DataTable, DataTableBody, DataTableHeader, DataTableHeaderColumn, DataTableRow, DataTableRowColumn } from "~/primitiveComponents/dataDisplay/DataTable";
export type VersionControlledProjectUsage = {
    ProjectName: string;
    ProjectId: string;
    ProjectSlug: string;
    SpaceId: string;
    Url: string;
    DefaultBranch: string;
    BasePath: string;
};
type VersionControlledProjectUsagesProps = {
    versionControlledProjects: VersionControlledProjectUsage[];
};
export function VersionControlledProjectUsages({ versionControlledProjects }: VersionControlledProjectUsagesProps) {
    if (!versionControlledProjects || versionControlledProjects.length === 0) {
        return null;
    }
    return (<DataTable>
            <DataTableHeader>
                <DataTableRow>
                    <DataTableHeaderColumn>Project</DataTableHeaderColumn>
                    <DataTableHeaderColumn>Repository</DataTableHeaderColumn>
                    <DataTableHeaderColumn>Default Branch</DataTableHeaderColumn>
                    <DataTableHeaderColumn>Git File Storage Directory</DataTableHeaderColumn>
                </DataTableRow>
            </DataTableHeader>
            <DataTableBody>
                {sortBy(versionControlledProjects, [(x) => x.ProjectName, "asc"]).map((usageEntry) => {
            return (<DataTableRow key={usageEntry.ProjectId}>
                            <DataTableRowColumn>
                                <InternalLink to={links.projectRootRedirect.generateUrl({ spaceId: usageEntry.SpaceId, projectSlug: usageEntry.ProjectSlug })}>{usageEntry.ProjectName}</InternalLink>
                            </DataTableRowColumn>
                            <DataTableRowColumn>
                                <ExternalLink href={usageEntry.Url}>{usageEntry.Url}</ExternalLink>
                            </DataTableRowColumn>
                            <DataTableRowColumn>
                                <code>{usageEntry.DefaultBranch}</code>
                            </DataTableRowColumn>
                            <DataTableRowColumn>
                                <code>{usageEntry.BasePath}</code>
                            </DataTableRowColumn>
                        </DataTableRow>);
        })}
            </DataTableBody>
        </DataTable>);
}
export async function getVersionControlledProjectUsagesIfFeatureToggleIsEnabled(improveConfigAsCodeProjectUsagesEnabled: boolean, repository: Repository): Promise<VersionControlledProjectUsage[]> {
    let versionControlledProjects: VersionControlledProjectUsage[] = [];
    if (improveConfigAsCodeProjectUsagesEnabled) {
        const allProjects = await repository.Projects.all();
        versionControlledProjects = allProjects
            .filter((project) => project.IsVersionControlled)
            .map((project) => {
            if (HasGitPersistenceSettings(project.PersistenceSettings)) {
                return {
                    ProjectName: project.Name,
                    ProjectId: project.Id,
                    ProjectSlug: project.Slug,
                    SpaceId: project.SpaceId,
                    Url: project.PersistenceSettings.Url,
                    DefaultBranch: project.PersistenceSettings.DefaultBranch,
                    BasePath: project.PersistenceSettings.BasePath,
                };
            }
            throw new Error("Project is not version controlled");
        });
    }
    return versionControlledProjects;
}
